import { IonIcon } from '@ionic/react';
import { alertCircleOutline, checkmarkCircleOutline } from 'ionicons/icons';
import { useCallback } from 'react';
import { InvoiceInList } from '../../interfaces/invoice.interface';

interface Props {
  data: InvoiceInList;
}

export const SentToAadeIcon = ({ data }: Props) => {
  const getIcon = useCallback(() => {
    if (data?.mark) {
      return <IonIcon icon={checkmarkCircleOutline} style={{ fontSize: 18 }} color="success"></IonIcon>;
    }

    if (data?.sentToAadeAt) {
      let icon = checkmarkCircleOutline;
      let color = 'secondary';
      if (data?.failedAt) {
        icon = alertCircleOutline;
        color = 'warning';
      }
      return <IonIcon icon={icon} style={{ fontSize: 18 }} color={color}></IonIcon>;
    }

    return <IonIcon icon={checkmarkCircleOutline} style={{ fontSize: 18 }} color="danger"></IonIcon>;
  }, [data?.failedAt, data?.mark, data?.sentToAadeAt]);

  return (
    <div className="flex-center-center-column-nowrap" style={{ position: 'relative' }}>
      <div className="text-shade normalText3" style={{ position: 'absolute', top: -18, right: -10 }}>
        {getIcon()}
      </div>
    </div>
  );
};
